import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function SalesReports (){
  const {user} = useUser()
  let view = contentLayout[modules.SalesReports]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.SalesReports.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.SalesReports}></Index>
 )
}

export default SalesReports
